<template>
    <div class="case">
        <div class="imageBox">
            <img class="image" :src="'/service/fileRes/dcmPicture?listId=' + info.imageId" alt="">
        </div>
        <div class="infos">
            <h2 class="title">{{info.title}}</h2>
            <p class="keyWords">{{info.keyWords}}</p>
            <p class="topic">{{info.topic}}</p>
            <p class="creatTime">{{info.createTime | formatTime}}</p>
        </div>
    </div>    
</template>

<script>
export default {
    props: {
        info: {}
    }
}
</script>

<style lang="scss" scoped>
    .case{
        padding: 20px 0;
        border-bottom: 1px solid #dddddd;
        cursor: pointer;
        &:hover .title{
            color: #2b85e4;
        }
        &::after {
            content: "";
            display: block;
            height: 0;
            clear: both;
            visibility: hidden;
        }
        .imageBox{
            float: left;
            width: 150px;
            height: 150px;
            margin-right: 15px;
            .image{
                width: 100%;
                height: 100%;
            }
        }
        .infos{
            float: left;
            width: 825px;
            .title{
                font-size: 20px;
            }
            .keyWords{
                color: #9ea7b4;
                font-size: 14px;
                // border: 1px solid #19be6b;
                // border-radius: 5px;

            }
            .topic{
                font-size: 18px;
                margin-top: 10px;
            }
            .creatTime{
                margin-top: 10px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/ClassicCase/Case.vue